var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['fixed-btns', _vm.language]},_vm._l((_vm.btnList),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.clickBanner(item, 'right-btn')}}},[_c('img',{staticClass:"iconfont-wrap",attrs:{"src":item.img}}),_c('div',{staticClass:"font"},[_vm._v(_vm._s(item.description))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }